import { jsx as _jsx } from "react/jsx-runtime";
import s from './button.module.scss';
export var Button = function (_a) {
    var text = _a.text, onClick = _a.onClick, className = _a.className, _b = _a.type, type = _b === void 0 ? 'button' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    return (_jsx("button", { className: "".concat(s.button, " ").concat(className), onClick: onClick, type: type, disabled: disabled, children: text }));
};
